// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"694":"component---src-core-share-share-block-template-tsx","853":"component---src-core-pages-page-template-js"}[chunkId] + "-" + {"694":"6251ea4658dbab09040e","853":"9da2e93b1cbf1c20404a"}[chunkId] + ".js";
};